import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../../../components/media-query';
import { smallPaddingVerticalBox } from '../../../components/view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    paddingLeft: mediaQuery.medium,
    flexDirection: 'row',
    alignItems: 'center',
  },
  innerContainer: {
    ...smallPaddingVerticalBox,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderBottomWidth: 1,
    paddingRight: mediaQuery.medium,
  },
  iconContainer: {
    width: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {},
  text: {
    flex: 1,
  },
});
